
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/[[...params]]",
      function () {
        return require("private-next-pages/auth/[[...params]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/[[...params]]"])
      });
    }
  